import React, { useContext } from "react";

import { CSContext } from "../contexts/CSContext";
import TextField from "Components/DesignSystem/TextField/TextField";

/**
 * Identifier field on the DS `TextField` (2026-09-08). The `required` marker is
 * the FieldTitle asterisk (was a hand-placed `tw-text-red-500` span), and the
 * disabled treatment is the token pair (was `tw-bg-gray-100`). Same wiring:
 * `setVersionName` gets the raw string, disabled in `edit`/`edit_version` modes.
 */
const CSIdentifierInput = (props: any) => {
    const { versionName, setVersionName } = useContext(CSContext)
    const disabled = ['edit', 'edit_version'].includes(props?.mode)
    return (
        <div className="tw-ml-5 tw-w-[25%]">
            <TextField
                label="Identifier Name"
                required
                data-testid="substitutions-identifier-input"
                onChange={(value) => setVersionName(value)}
                value={versionName}
                placeholder="Enter Identifier"
                disabled={disabled}
            />
        </div>
    );
};

export default CSIdentifierInput;
